import React from 'react'
import { Provider } from 'react-redux'

import configureStore from '~src/store/create-store'

const store = configureStore()

export default ({ element }): React.ReactElement => (
  <Provider store={store}>{element}</Provider>
)
